module.exports = __webpack_public_path__ + "static/media/inventariar.973e73ee.png";